/**
 * 获取合法输入字符
 * @param str
 */
const getNumberStr = (str: string = '') => {
    return `${str}`.split('').filter((item: string) => {
        const charCode = item.charCodeAt(0);
        return (charCode > 47 && charCode < 58) || item === '.';
    }).join('');
};

/**
 * 输入框精度限制
 * @param {number} digital
 * @returns {(value: any) => string}
 */
const toDecimal = (digital: number = 2) => (value: any) => {
    const val = String(value).includes('-') ? '0' + String(Number(value) + 1).substr(1) : value;
    let num = getNumberStr(val);
    let [,x] = num.split('.');
    return x && x.length > digital ? parseFloat(num).toFixed(digital + 15).slice(0, -15) : num;
};

/**
 * 过滤form - select组件非法值
 */
// value: string, options: Array<{ label: string; value: string; }>, separator: string = ','
const toSelected = ({ value, options, separator = ',', itemKey = 'value' }: {
    value: string;
    options: Array<any>;
    itemKey?: string;
    separator?: string;
}): Array<string> | string | void => {
    if (!Array.isArray(options) || !options.length || (value !== '' && !value)) return;
    const enabled = options.map((item: any) => item[itemKey]);
    const val = separator ? value.split(separator) : value;
    // 多选情况，过滤value中，不存在options中的值
    if (Array.isArray(val)) return val.filter((key: string) => enabled.includes(key));
    if (typeof val === 'string' && enabled.includes(val)) return val;
};

// query string to key-value
const toParams = (url: string = '') => {
    const [, query = ''] = url.split('?');
    return query.split('&').filter(Boolean).reduce((s: Object, p: string = '') => {
        const [key, value] = p.split('=');
        return { ...s, [key]: value };
    }, {} as any);
};

// key-value to query string
const toQuery = (params: { [key: string]: string; } = {}, delKeys: Array<string> = []) => {
    let keys = Object.keys(params);
    if (!keys.length) return '';
    if (delKeys.length) keys = keys.filter(key => !delKeys.includes(key));
    return keys.map(key => `${key}=${params[key] || ''}`).join('&');
};

export {
    getNumberStr,
    toDecimal,
    toSelected,
    toParams,
    toQuery
};
